module.exports = __webpack_public_path__ + "../front/img/468_3_skuffer+hylde.09990c5a.svg";